const controlPanelSlider = new (function () {
    const self = this;
    this.currentSlide = 0;
    // Updated selectors to match new classes in HTML
    this.slides = document.querySelectorAll('.js-simple-control-panel-slides');
    this.item = document.querySelectorAll('.js-simple-control-panel-item');
    // Select images inside the slides
    this.images = document.querySelectorAll('.js-simple-control-panel-slides img');

    this.animation;

    this.init = () => {
        // Add click event listener to each pagination item
        this.item.forEach((element) => {
            element.addEventListener('click', handleClickPagination);
        });

        startInterval();
        restartAnimationsAndTimer();
    };

    function handleClickPagination(event) {
        const pageSelected = event.currentTarget.dataset.slide;
        self.currentSlide = Number(pageSelected);
        updateSlidesAndPagination(self.currentSlide);

        // Update the active image based on the current slide
        updateActiveImage(self.currentSlide);

        // Restart animations and the interval timer when clicked manually
        restartAnimationsAndTimer();
    }

    function handleIntervalPagination() {
        self.currentSlide++;
        if (self.currentSlide >= self.slides.length) {
            self.currentSlide = 0;
        }
        updateSlidesAndPagination(self.currentSlide);
        updateActiveImage(self.currentSlide);
    }

    function updateSlidesAndPagination(slideIndex) {
        // Remove active classes from all slides and pagination items
        self.slides.forEach((slide) => {
            slide.classList.remove('active');
        });

        self.item.forEach((item) => {
            item.classList.remove('active');
        });

        // Add the active class to the current slide and corresponding item
        const activeSlide = self.slides[slideIndex];
        activeSlide.classList.add('active');

        const activeItem = self.item[slideIndex];
        activeItem.classList.add('active');
    }

    function updateActiveImage(slideIndex) {
        // Remove active class from all images
        self.images.forEach((image) => {
            image.classList.remove('active');
        });

        // Find the image whose parent <li> has data-page equal to the slideIndex
        const activeImage = Array.from(self.images).find((img) => {
            const parentLi = img.closest('li');
            return parentLi && parentLi.dataset.page == slideIndex;
        });
        if (activeImage) {
            activeImage.classList.add('active');
        }
    }

    function restartAnimationsAndTimer() {
        restartAnimations();
        clearInterval(self.animation);
        startInterval();
    }

    function startInterval() {
        // Adjust the timing as needed (currently set to 9993 milliseconds)
        self.animation = setInterval(handleIntervalPagination, 9993);
    }

    function restartAnimations() {
        // Restart animations with the name 'beam-fly'
        const anim = document.getAnimations();
        anim.forEach((animation) => {
            if (
                animation.animationName === 'beam-fly' &&
                animation.playState === 'running'
            ) {
                animation.cancel();
                animation.play();
            }
        });
    }
})();

controlPanelSlider.init();
